'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

/**
 * 涂抹组件
 */
var ScratchOut = React.createClass({
  render: function () {
    return (<img className="component-SimpleCom"
                 src={assetsHelper.getComponentAsset('ScratchOut')}
    />);
  }
});

module.exports = ScratchOut;




// WEBPACK FOOTER //
// ./src/views/Components/ScratchOut.jsx